
import {  sendApi } from ".";
import { T_Error } from "../model/errorModel";

async function errorList(data?: any) {

    const response = await sendApi({
      method: "post",
      url: "/error/list",
      data: {
        ...data,
      },
    });

    return response;
  }

async function errorCreate(data1?:T_Error){

  console.log("errordata:",data1);
  const response = await sendApi({
    method: "post",
    url: "/error/insert",
    data: {
      ...data1,
    },
  });

  return response;
} 

async function errorUpdate(data1?:T_Error){

  console.log("errordata update:",data1);
  const response = await sendApi({
    method: "post",
    url: "/error/update",
    data: {
      ...data1,
    },
  });

  return response;
}  

async function errorDelete(data1?:T_Error){

  console.log("errordata delete:",data1);
  const response = await sendApi({
    method: "post",
    url: "/error/delete",
    data: {
      ...data1,
    },
  });

  return response;
}  

const error = {
    errorList,
    errorCreate,
    errorUpdate,
    errorDelete,
  };
  export default error;

